/**
 * Client-side input formatting only.
 * All forms in this edition are visual demos: no POST, email, or storage.
 */

export function formatPhone(value) {
  // Contact inquiries can include non-US phone numbers when SMS is not opted in.
  // Preserve those numbers instead of silently stripping their country codes.
  const raw = String(value || '').replace(/[^0-9+ ()-]/g, '').slice(0, 28);
  const d = raw.replace(/\D/g, '');
  if ((raw.trim().startsWith('+') && !raw.trim().startsWith('+1')) || d.length > 11 || (d.length === 11 && !d.startsWith('1'))) return raw;
  const n = d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  if (n.length <= 3) return n;
  if (n.length <= 6) return `(${n.slice(0, 3)}) ${n.slice(3)}`;
  return `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6, 10)}`;
}

export function phoneDigits(value) {
  const d = (value || '').replace(/\D/g, '');
  return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
}
